module.exports = __webpack_public_path__ + "account/assets/webinar.fbbe3cf2.svg";